import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudUpload } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import { UseCampaignPayload } from '@hooks/useCampaign'

import handleCallbackAction from '@functions/handleCallbackAction'

type campaignPayloadProps = {
  campaignPayload: UseCampaignPayload,
}

const PortalTools = (props: campaignPayloadProps) => {
  const { campaignPayload } = props

  const {
    campaign: { published },
    callbacks: { portalSync: syncFn },
    syncing,
  } = campaignPayload

  const portalSyncPayload = {
    callbacks: {
      action: syncFn,
    },
    toastText: 'Sync queued',
  }

  if (!published) return null

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        data-test-id="sendDataButton"
        icon={<FontAwesomeIcon icon={faCloudUpload} />}
        loading={syncing}
        onClick={() => handleCallbackAction(portalSyncPayload)}
        size="medium"
      >
        Send Data
      </Button>
    </Tools>
  )
}

export default PortalTools
